/**
 * Tag-based authors — extracts author names from tags prefixed "author: ".
 * Convention: tag named "author: Full Name" (slug: "author-full-name").
 * Handles: blog table rows, post byline.
 */
(function () {
    'use strict';

    var PREFIX = 'author-';
    var NAME_RE = /^author:\s*/i;

    function extractAuthors(raw) {
        if (!raw) return [];
        return raw.split('||').filter(Boolean).reduce(function (acc, entry) {
            var parts = entry.split('::');
            var slug = parts[0];
            var name = parts[1];
            if (slug && slug.indexOf(PREFIX) === 0 && name) {
                acc.push(name.replace(NAME_RE, '').trim());
            }
            return acc;
        }, []);
    }

    // --- Blog table rows: show authors on separate lines ---
    var rows = [].slice.call(document.querySelectorAll('.content-row__author[data-tag-author]'));
    rows.forEach(function (span) {
        var authors = extractAuthors(span.getAttribute('data-tag-author'));
        if (authors.length) {
            span.innerHTML = authors.map(function (n) {
                return '<span class="content-row__author-name">' + n + '</span>';
            }).join('');
        }
    });

    // --- Post byline: populate author names ---
    var bylines = [].slice.call(document.querySelectorAll('.article-byline[data-tag-author]'));
    bylines.forEach(function (byline) {
        var target = byline.querySelector('[data-tag-author-target]');
        if (!target) return;
        var authors = extractAuthors(byline.getAttribute('data-tag-author'));
        if (authors.length) {
            target.textContent = authors.join(', ');
        }
    });
})();
